module.exports = __webpack_public_path__ + "img/revenue-streams.0840114d.svg";